/* HLR Cart Price Override — reads _Calculated Price from line item
   properties and overrides displayed prices on the cart page & drawer.
   The Cart Transform Shopify Function handles the actual checkout price. */
(function() {
  'use strict';

  // Get Shopify exchange rate (USD → active currency)
  function getRate() {
    var curr = window.Shopify && window.Shopify.currency || {};
    return parseFloat(curr.rate) || 1;
  }

  function getCurrencySymbol() {
    var curr = window.Shopify && window.Shopify.currency || {};
    var code = curr.active || 'USD';
    if (code === 'GBP') return '\u00a3';
    if (code === 'EUR') return '\u20ac';
    if (code === 'USD') return '$';
    return code + ' ';
  }

  function fmt(cents) {
    var symbol = getCurrencySymbol();
    return symbol + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Parse _Calculated Price (always USD), convert to active currency cents
  function parseCents(s) {
    var usdAmount = parseFloat(s.replace(/[^0-9.]/g, ''));
    var rate = getRate();
    return Math.round(usdAmount * rate * 100);
  }

  function run() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var total = 0, changed = false;

        cart.items.forEach(function(item) {
          var cp = item.properties && item.properties['_Calculated Price'];
          var cents = cp ? parseCents(cp) : item.final_line_price;
          total += cents * item.quantity;
          if (!cp) { total += 0; return; }
          changed = true;

          var row = document.querySelector('[data-key="' + item.key + '"]');
          if (!row) return;

          var el = row.querySelector('.cart__final-price');
          if (!el) return;

          // Find the deepest text node or span showing the price and replace it
          var divs = el.querySelectorAll('div:not(.cart-item__discounted-prices)');
          var found = false;
          divs.forEach(function(d) {
            if (d.children.length === 0 || d.classList.contains('skeleton-text')) {
              var txt = d.textContent.trim();
              if (/^[£$€¥₩₹]/.test(txt) || /^free$/i.test(txt)) {
                d.textContent = fmt(cents);
                found = true;
              }
            }
          });

          if (!found) {
            // Try spans
            var spans = el.querySelectorAll('span:not(.visually-hidden)');
            spans.forEach(function(sp) {
              var txt = sp.textContent.trim();
              if (/^[£$€¥₩₹]/.test(txt) || /^free$/i.test(txt)) {
                sp.textContent = fmt(cents);
                found = true;
              }
            });
          }

          if (!found) {
            // Brute force: walk text nodes
            var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
            var node;
            while (node = walker.nextNode()) {
              if (/[£$€¥₩₹][\d,.]+/.test(node.textContent) || /free/i.test(node.textContent)) {
                node.textContent = fmt(cents);
                found = true;
              }
            }
          }
        });

        if (!changed) return;

        // Update subtotal
        document.querySelectorAll('.cart__totals__subtotal-value').forEach(function(el) {
          var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
          var node;
          while (node = walker.nextNode()) {
            if (/[£$€¥₩₹][\d,.]+/.test(node.textContent)) {
              node.textContent = node.textContent.replace(/[£$€¥₩₹][\d,.]+/, fmt(total));
            }
          }
        });
      })
      .catch(function(e) { console.warn('HLR cart override:', e); });
  }

  // Only run if cart items exist on the page
  function tryRun() {
    if (document.querySelector('[data-key]')) {
      run();
    }
  }

  // Run on DOMContentLoaded and after short delay for dynamic content
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(tryRun, 300); });
  } else {
    setTimeout(tryRun, 300);
  }

  // Re-run periodically to handle AJAX cart updates and drawer opens
  setInterval(tryRun, 2500);

  // Observe for cart drawer opening
  new MutationObserver(function(muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) {
        var dominated = false;
        muts[i].addedNodes.forEach(function(n) {
          if (n.nodeType === 1 && n.querySelector && n.querySelector('[data-key]')) dominated = true;
        });
        if (dominated) { setTimeout(run, 300); return; }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();

